<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Código</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            placeholder="Digite o código do modelo"
                            v-model="codigo"
                            :state="$v.codigo.$error ? false : null"
                            @input.native="$v.codigo.$touch()"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O código do modelo é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Descrição</label>
                    <b-input-group>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="3"
                            :state="$v.descricao.$error ? false : null"
                            @input.native="$v.descricao.$touch()"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição do modelo é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Arquivo</label>
                    <b-form-file
                        v-model="arquivo"
                        :state="arquivoOk"
                        placeholder="Selecione o arquivo..."
                        ref="arquivoInput"
                        browse-text="Selecionar"
                    ></b-form-file>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Campos do Modelo</label>
                    <b-input-group>
                        <b-form-textarea
                            v-model="objeto"
                            :rows="3"
                            :state="$v.objeto.$error ? false : null"
                            @input.native="$v.objeto.$touch()"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >Os campos do modelo são
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="cancelar()"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        modelo: {
            type: Object,
            default: () => ({})
        },

        operacao: {
            type: String,
            default: () => 'INSERÇÃO'
        }
    },

    data() {
        return {
            erros: [],
            codigo: null,
            descricao: null,
            arquivo: null,
            objeto: null
        }
    },

    mounted() {
        if (this.modelo) {
            this.preencherForm()
        }
    },

    methods: {
        cancelar() {
            this.resetForm()
            this.$emit('fechar')
        },

        resetForm() {
            this.codigo = null
            this.descricao = null
            this.arquivo = null
            this.objeto = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        setErros(errors) {
            this.erros = errors
        },

        preencherForm() {
            this.codigo = this.modelo.codigo
            this.descricao = this.modelo.descricao
            this.objeto = this.modelo.objeto
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Modelo',
                html: `Confirma a ${this.operacao.toLowerCase()} do modelo <b>${
                    this.codigo
                }</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let modeloDto = {
                codigo: this.codigo,
                descricao: this.descricao,
                arquivo: this.arquivo,
                objeto: this.objeto
            }
            this.$emit('salvar', modeloDto)
        }
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        arquivoOk() {
            if (this.operacao == 'INSERÇÃO') {
                return this.arquivo !== null
            }
            return true
        }
    },

    watch: {},

    validations: {
        codigo: {
            required
        },
        descricao: {
            required
        },
        arquivo: {
            arquivoOk(value) {
                return this.arquivoOk
            }
        },
        objeto: {
            required
        }
    }
}
</script>
